
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 3c-.563 0-1 .469-1 1v1h14V4c0-.531-.469-1-1-1H2zM1 6v1h14V6H1zm0 2v4c0 .563.438 1 1 1h12c.531 0 1-.438 1-1V8H1zM0 4c0-1.094.875-2 2-2h12c1.094 0 2 .906 2 2v8c0 1.125-.906 2-2 2H2c-1.125 0-2-.875-2-2V4zm3 7.5c0-.25.219-.5.5-.5h1c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-1a.494.494 0 01-.5-.5zm3 0c0-.25.219-.5.5-.5h3c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-3a.494.494 0 01-.5-.5z","fill":"#000"}})])
          )
        }
      }
    